<template>
    <div class="mdc-textfield-container">
        <label ref="container" :id="id" class="mdc-text-field mdc-text-field--outlined outlined-density-3">
            <input type="text" class="mdc-text-field__input" :name="id" :required="required" v-model="text"
                   :maxlength="maxlength">
            <span class="mdc-notched-outline">
                <span class="mdc-notched-outline__leading"></span>
                <span class="mdc-notched-outline__notch">
                    <span class="mdc-floating-label" :for="id">{{placeholder}}</span>
                </span>
                <span class="mdc-notched-outline__trailing"></span>
            </span>
        </label>
        <div class="mdc-text-field-helper-line" v-if="errorMessage">
            <div class="mdc-text-field-helper-text mdc-text-field-helper-text--validation-msg" id="passwordErrorText" aria-hidden="true">{{errorMessage}}</div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {MDCTextField} from '../../static/mdctextfield/mdc.textfield'

    export default {
        name: "mdc-textfield",
        props: {
            id: String,
            placeholder: String,
            value: String,
            required: Boolean,
            errorMessage: String,
            maxlength: Number,
            isValid: Boolean,
        },
        data() {
            return {
                text: this.value,
                mdcTextfield: null,
            }
        },

        watch: {
            value: function (val) {
                this.text = val;
            },
            text: function (val) {
                this.$emit('input', val);
            },
            isValid: {
                immediate: true,
                handler: 'setValid'
            }
        },

        mounted: function () {
            this.mdcTextfield = new MDCTextField(this.$refs['container']);
        },
        methods: {
            setValid: function (val) {
                Vue.nextTick(()=>{
                    this.mdcTextfield.valid = val;
                })
            },
        }
    }
</script>

<style lang="scss">
    @import "./../../static/mdctextfield/mdc.textfield.css";
    .mdc-textfield-container {
        margin-bottom: 32px;
        input { height: 54px; }
        label { width: 100%; }
        .mdc-text-field-helper-line {
            margin-bottom: -19px;
        }
    }
</style>